import { gql } from '@apollo/client';

export const GET_PAGINATED_ROOMS = gql`
  query GET_PAGINATED_ROOMS($limit: Float!, $page: Float!) {
    getPaginatedRooms(limit: $limit, page: $page) {
      __typename
      id
      createdAt
      recentMessage
      hasUnreadMessage
      chatType

      owner {
        id
        email
        avatar {
          fileUrl
        }

        profile {
          id
          name
        }
      }

      members {
        email
        id
        avatar {
          fileUrl
        }
        profile {
          id
          name
        }
      }
    }
  }
`;
